import { render, staticRenderFns } from "./ManageAccountEmptyCard.vue?vue&type=template&id=1ab539d5&"
import script from "./ManageAccountEmptyCard.vue?vue&type=script&lang=js&"
export * from "./ManageAccountEmptyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports